import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";

function RSPChange_Breadcrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid mt-4">
      {vPathName === "/ItemRSPRequest" ? (
        <div>
          <span className="breadcrumb-not-active ">RSP Change Request </span>
        </div>
      ) : vPathName === "/RSPChangeRequestDetail" ? (
        <div className={"d-flex align-items-center"}>
          <Link
            to="/ItemRSPRequest"
            state={location}
            className={"breadcrumb-active mr-2"}
          >
            RSP Change Request
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1px" }} />
          <div>
            <span className="breadcrumb-not-active">
              RSP Change Request Detail{" "}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default RSPChange_Breadcrumbs;
